import { Link } from "react-router-dom";
import {
  Instagram, Facebook, Youtube, Store, MapPin, Phone, Mail,
  CreditCard, Stethoscope, ScanLine, Sofa,
} from "lucide-react";

const SERVICES = [
  { icon: CreditCard, label: "Pay After Check" },
  { icon: Stethoscope, label: "AI Plant Doctor" },
  { icon: ScanLine, label: "Plant Scan" },
  { icon: Sofa, label: "Design My Space" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 bg-[var(--yp-primary)] text-white/85">
      <div className="mx-auto max-w-7xl px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="mb-4">
            <div className="font-serif-display text-xl text-white font-semibold">YourPlants.in</div>
            <div className="text-[10px] uppercase tracking-widest opacity-80">Aapka Plant, Aapke Liye</div>
          </div>
          <p className="text-sm leading-relaxed opacity-80">
            A smart plant marketplace delivering quality plants from trusted local nurseries to your doorstep with Pay After Check, AI Plant Doctor, Plant Scan, and Design My Space services.
          </p>
          <div className="flex items-center gap-4 mt-5">
            {SERVICES.map(({ icon: Icon, label }) => (
              <span key={label} title={label} aria-label={label} className="flex items-center justify-center w-8 h-8 rounded-full border border-white/30 text-white">
                <Icon size={16} strokeWidth={1.75} />
              </span>
            ))}
          </div>
          <div className="flex items-center gap-4 mt-6">
            <a href="https://www.instagram.com/yourplantsindia/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-[var(--yp-accent)]"><Instagram size={18} strokeWidth={1.75} /></a>
            <a href="https://www.facebook.com/yourplantsindia" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-[var(--yp-accent)]"><Facebook size={18} strokeWidth={1.75} /></a>
            <a href="https://www.youtube.com/@Yourplantsofficial" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="hover:text-[var(--yp-accent)]"><Youtube size={18} strokeWidth={1.75} /></a>
            <a href="https://www.indiamart.com/iartraders/profile.html?srsltid=AU7gw4W3-fzfdrJPkB_8BpZzESt93tjyNmnVRFocDALh7hqNEWIJ8mwM" target="_blank" rel="noopener noreferrer" aria-label="IndiaMart" className="hover:text-[var(--yp-accent)]"><Store size={18} strokeWidth={1.75} /></a>
          </div>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/indoor-plants" className="hover:text-[var(--yp-accent)]">Indoor Plants</Link></li>
            <li><Link to="/shop/outdoor-plants" className="hover:text-[var(--yp-accent)]">Outdoor Plants</Link></li>
            <li><Link to="/shop/flowering-plants" className="hover:text-[var(--yp-accent)]">Flowering Plants</Link></li>
            <li><Link to="/shop/fruit-plants" className="hover:text-[var(--yp-accent)]">Fruit Plants</Link></li>
            <li><Link to="/shop/pots-planters" className="hover:text-[var(--yp-accent)]">Pots & Planters</Link></li>
            <li><Link to="/shop/fertilizers" className="hover:text-[var(--yp-accent)]">Fertilizers</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">Services</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-[var(--yp-accent)]">Landscaping</Link></li>
            <li><Link to="/site-visit" className="hover:text-[var(--yp-accent)]">Book Nursery Visit</Link></li>
            <li><Link to="/bulk" className="hover:text-[var(--yp-accent)]">Bulk Orders</Link></li>
            <li><Link to="/track" className="hover:text-[var(--yp-accent)]">Track Order</Link></li>
            <li><Link to="/blogs" className="hover:text-[var(--yp-accent)]">Blog</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-white font-semibold mb-3">Contact</div>
          <ul className="space-y-2 text-sm opacity-90">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5" /> Assam · Meghalaya · Arunachal Pradesh · Delhi</li>
            <li className="flex items-center gap-2"><Phone size={16} /> +91 8011441118</li>
            <li className="flex items-center gap-2"><Mail size={16} /> support@yourplants.in</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-5 text-xs opacity-75 flex flex-col sm:flex-row items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} YourPlants.in — All rights reserved.</div>
          <div className="flex gap-4">
            <Link to="/policies/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/policies/terms" className="hover:text-white">Terms</Link>
            <Link to="/policies/shipping" className="hover:text-white">Shipping</Link>
            <Link to="/policies/refund" className="hover:text-white">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
